import { OrgDto } from "@gap/backend/app-services/org/models/OrgDto"
import { apiClient, apiClientSilent } from "api/trpc/trpc-client"
import Loader from "reusable/mobx-helpers/Loader"
import ModalState from "reusable/mobx-helpers/ModalState"
import { formHandler, FormHandlerConfig } from "reusable/mobx-store-utils/form-handlers/new/form-handler"
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import { snackbarError, snackbarSuccess } from "reusable/mui/snackbar/snackbar"

export default class DevDeleteOrgStore {
   orgLoader = new Loader()
   deleteDialog = new ModalState()
   org: OrgDto.minimal | undefined = undefined
   fields = {
      orgId: '',
      orgName: ''
   }

   constructor() { }

   get formHandler() {
      return formHandler(this.fields, {
         orgId: { type: 'string' },
         orgName: { type: 'string' }
      } satisfies FormHandlerConfig)
   }

   fetchOrg = async () => {
      await this.orgLoader.executeLoading(async () => {
         try {
            this.org = await apiClientSilent.org.getMinimalOrgById.query({
               orgId: this.fields.orgId
            })
         } catch {
            snackbarError('No such org')
         }
      })
   }

   deleteOrg = async () => {
      await this.orgLoader.executeLoading(async () => {
         await apiClient.dev.deleteOrg.mutate({
            orgId: this.fields.orgId
         })
         snackbarSuccess(`${this.org?.name} deleted!`)
         this.org = undefined
         this.fields.orgId = ''
         this.fields.orgName = ''
         this.deleteDialog.close()
      })
   }
}

export const { Provider: DevDeleteOrgStoreProvider, useProvidedStore: useDevDeleteOrgStore } = createStoreContext(DevDeleteOrgStore)
